"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _task = require("@/api/task");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TaskDefinition',
  data: function data() {
    return {
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 任务表格数据
      taskList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        page: 1,
        limit: 20,
        taskName: undefined,
        taskStatus: undefined
      },
      // 表单参数
      form: {
        taskId: undefined,
        taskName: undefined,
        taskUrl: undefined,
        dailyLimit: 1,
        rewardPoints: 0,
        remark: undefined,
        taskStatus: 1
      },
      // 表单校验
      rules: {
        taskName: [{
          required: true,
          message: '任务名称不能为空',
          trigger: 'blur'
        }, {
          max: 50,
          message: '任务名称长度不能超过50个字符',
          trigger: 'blur'
        }],
        taskUrl: [{
          required: true,
          message: '任务链接不能为空',
          trigger: 'blur'
        }, {
          max: 200,
          message: '任务链接长度不能超过200个字符',
          trigger: 'blur'
        }],
        dailyLimit: [{
          required: true,
          message: '每日限制次数不能为空',
          trigger: 'blur'
        }],
        rewardPoints: [{
          required: true,
          message: '奖励积分不能为空',
          trigger: 'blur'
        }],
        remark: [{
          max: 200,
          message: '任务描述长度不能超过200个字符',
          trigger: 'blur'
        }],
        taskStatus: [{
          required: true,
          message: '任务状态不能为空',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    /** 查询任务列表 */getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _task.getTaskList)({
        page: this.queryParams.page,
        limit: this.queryParams.limit,
        taskName: this.queryParams.taskName,
        taskStatus: this.queryParams.taskStatus
      }).then(function (res) {
        console.log('API返回数据：', res);
        _this.taskList = res.list || [];
        _this.total = res.total || 0;
        _this.loading = false;
      }).catch(function (error) {
        console.error('API错误：', error);
        _this.$message.error('获取数据失败');
        _this.loading = false;
      });
    },
    /** 取消按钮 */cancel: function cancel() {
      this.open = false;
      this.reset();
    },
    /** 表单重置 */reset: function reset() {
      console.log('reset called');
      this.form = {
        taskId: undefined,
        taskName: undefined,
        taskUrl: undefined,
        dailyLimit: 1,
        rewardPoints: 0,
        remark: undefined,
        taskStatus: 1
      };
      this.resetForm('form');
    },
    /** 搜索按钮操作 */handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 重置按钮操作 */resetQuery: function resetQuery() {
      this.queryParams.taskName = undefined;
      this.queryParams.taskStatus = undefined;
      this.handleQuery();
    },
    /** 新增按钮操作 */handleAdd: function handleAdd() {
      console.log('handleAdd called');
      this.reset();
      this.open = true;
      this.title = '添加任务';
      console.log('open:', this.open);
    },
    /** 修改按钮操作 */handleUpdate: function handleUpdate(row) {
      this.reset();
      this.form = _objectSpread({}, row);
      this.open = true;
      this.title = '修改任务';
    },
    /** 提交按钮 */submitForm: function submitForm() {
      var _this2 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          if (_this2.form.taskId) {
            (0, _task.updateTask)(_this2.form).then(function (res) {
              console.log('更新任务返回数据：', res);
              _this2.$message.success('修改成功');
              _this2.open = false;
              _this2.getList();
            }).catch(function (error) {
              console.error('更新任务失败：', error);
              _this2.$message.error('更新任务失败');
            });
          } else {
            (0, _task.createTask)(_this2.form).then(function (res) {
              console.log('创建任务返回数据：', res);
              _this2.$message.success('新增成功');
              _this2.open = false;
              _this2.getList();
            }).catch(function (error) {
              console.error('创建任务失败：', error);
              _this2.$message.error('创建任务失败');
            });
          }
        }
      });
    },
    /** 删除按钮操作 */handleDelete: function handleDelete(row) {
      var _this3 = this;
      this.$modal.confirm('是否确认删除任务名称为"' + row.taskName + '"的数据项？').then(function () {
        return (0, _task.deleteTask)(row.taskId);
      }).then(function () {
        _this3.$message.success('删除成功');
        _this3.getList();
      }).catch(function (error) {
        console.error('删除任务失败：', error);
        _this3.$message.error('删除任务失败');
      });
    }
  }
};